import { Vue } from "vue-property-decorator";
import axios, { AxiosRequestConfig } from "axios";

import { AuthTokenService } from ".";
import router from "@/router";

export const AxiosFactory = new Vue({
  methods: {
    create() {
      const config: AxiosRequestConfig = {
        baseURL: process.env.VUE_APP_WEBAPI_URL,
        headers: {
          Pragma: "no-cache",
        },
      };

      if (this.$auth.isAuthenticated()) {
        config.headers.Authorization = `Bearer ${this.$auth.getToken()}`;
        AuthTokenService.emitTokenRefreshIfNecessary();
      }

      const axiosInstance = axios.create(config);

      axiosInstance.interceptors.response.use(
        response => response,
        error => this.onError(error),
      );

      return axiosInstance;
    },
    onError(error: any) {
      // 422 is model validation error and we don't want any extra handling in that case
      if (error && error.response && error.response.status && error.response.status !== 422) {
        const errMessageObj: any = { title: "Error", message: "", type: "error" };

        switch (error.response.status) {
          case 401: {
            if (!this.$auth.isAuthenticated()) {
              errMessageObj.message = "Invalid session, please log in.";
              router.push("/login");
            } else {
              errMessageObj.message = "Unauthorized action.";
            }
            break;
          }
          case 403: {
            errMessageObj.message = "Insufficient permissions.";
            break;
          }
          case 500: {
            errMessageObj.message = error.response.data.message;
            break;
          }
          default: {
            errMessageObj.message = "An error occurred.";
            break;
          }
        }
        this.$notify(errMessageObj);
      }

      return Promise.reject(error);
    },
  },
});
